/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Filters from '../../Filters';
import useForm from '../../../hooks/useForm';
import { ControlTable } from '../../Table';
import { taxpayerScheduleCategoryList } from '../../../apis/tax-portal/taxpayer';
import TaxpayerScheduleCategory from './TaxpayerScheduleCategory';
import { cloneDeep } from 'lodash';

const TaxpayerScheduleCategories = () => {
  const [mode, setMode] = useState('create');
  const [tableButtons, setTableButtons] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [fields] = useState([
    {
      title: "카테고리명",
      key: "name",
    },
    {
      title: "노출색상",
      key: "color",
      onValue: (v) => (
        <span style={{
          backgroundColor: v,
          color: "white",
          padding: "10px 16px",
          marginLeft: "8px",
          borderRadius: "5px",
          fontWeight: "bold"
        }}
        >
          {v}
        </span>
      )
    },
    {
      title: "wecake 기본 카테고리",
      key: "isDefault",
      onValue: (v) => v ? "O" : "X"
    },
    {
      title: "사용 여부",
      key: "isActive",
      onValue: (v) => v ? "활성" : "비활성"
    },
    {
      title: "등록일",
      key: "createdTime",
      type: "datetime",
    }
  ]);
  const [filters] = useState([{
    title: "카테고리명",
    key: "search.name",
  }, {
    title: "사용여부",
    key: "search.isActive",
    type: "select",
    options: {
      list: [{ label: "전체", value: "all" }, { label: "활성", value: 1 }, { label: "비활성", value: 0 }]
    },
  }]);


  const openDetail = (data, e) => {
    setSelectedItem(data);
    setMode("update");
    setDetailOpen(true);
  };

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedList,
    setSelectedList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    reSubmit,
  } = useForm({
    order: [
      {
        createdTime: "desc",
      },
    ],
    search: {
      isActive: "all"
    },
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = (form) => {
    const params = cloneDeep(form);
    if (params?.search?.isActive === "all") {
      delete params.search.isActive;
    }
    taxpayerScheduleCategoryList(params)
      .then(res => {
        const { rows = [], count = 0 } = res;
        setTotal(count);
        setList(rows);
      })
      .finally(() => setIsLoading(false));
  };

  const cancelSubmit = () => {
    reSubmit();
    setMode("create");
  };

  useEffect(() => {
    setTableButtons([
      // {
      //   label: "사용여부 변경",
      //   color: "line",
      //   disabled: isEmpty(selectedList),
      //   action: () => {

      // if (selectedList.length > 0) {
      //   systemAlert(`"${selectedList[0].name}" ${selectedList.length - 1 > 0 ? ` 외 ${selectedList.length - 1}개` : ""}을(를) 삭제하시겠습니까?`, {
      //     buttons: [
      //       {
      //         color: 'text',
      //         label: '취소'
      //       },
      //       {
      //         label: '삭제',
      //         color: 'red',
      //         onClick: () => {
      //           deleteTaxpayerScheduleCategory({ idx: selectedList.map(item => item.idx) })
      //             .then(() => {
      //               toast.success("삭제가 완료되었습니다.");
      //               submit && submit(form);
      //               setSelectedList([]);
      //             }).catch(err => {
      //               console.error(err.response);
      //             }).finally(() => {
      //               setIsLoading(false);
      //             });
      //         }
      //       }
      //     ]
      //   });
      // }
      //   },
      // },
      {
        label: "카테고리 등록",
        action: () => {
          setDetailOpen(true);
        },
      }
    ]);
  }, [selectedList]);

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isControl
        fields={fields}
        isHideAllCheck
        list={list}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        onSelect={openDetail}
        submit={handleSubmit}
      />

      <TaxpayerScheduleCategory
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={cancelSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        mode={mode}
      />
    </>
  );
};

export default TaxpayerScheduleCategories;